// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { State } from '../../types.tsx';

export const resetDraftArticleData =
	(resetDelete: boolean) =>
	({ setState, getState }: StoreActionApi<State>) => {
		setState({
			...getState(),
			draftShareId: '',
			closed: false,
			published: false,
			showConfluenceCreatePageError: false,
			spaceKey: '',
			...(resetDelete && { deleted: false, articleId: '' }),
		});
	};
